import nodemailer from 'nodemailer'
import path from 'path'
import ejs from 'ejs'
import dotenv from 'dotenv';
dotenv.config();

// host: process.env.EMAIL_HOST,
// port: parseInt(process.env.EMAIL_PORT),
// secure: process.env.EMAIL_SECURE === 'true',
// auth: {
//     user: process.env.GMAIL_APIKEY,
//     pass: process.env.GMAIL_PASSWORD,
// },

const domainName = "Gard Labour Hire"
const companyLogo = process.env.COMPANY_LOGO_S3_BASE_URL
export const sendEmail = async (toEmail, subject, templateName, additionalData, attachments = []) => {
    try {

        const transporter = nodemailer.createTransport({

            service: 'gmail',
            port: 587,
            secure: false,
            auth: {
                user: process.env.GMAIL_USER,
                pass: process.env.GMAIL_PASSWORD
            },
        });



        const defaultTemplateData = {
            domainName: domainName,
            copyRightYear: new Date().getFullYear(),
        };

        const templateData = {
            ...defaultTemplateData,
            ...additionalData,
        };

        const templatePath = path.join(__dirname, 'templates', `${templateName}.ejs`);


        const html = await ejs.renderFile(templatePath, templateData);

        const mailOption = {
            from: process.env.GMAIL_USER,
            to: toEmail,
            subject: subject,
            text: templateData.text ?? '',
            html: html,
            attachments: attachments,
        };

        await transporter.sendMail(mailOption);
        console.log("Email Sent Succesfully")

    } catch (error) {
        console.error("Email not sent:", error);
    }
};





export const sendWelcomEmail = async (toEmail, name) => {
    const subject = `Welcome to ${domainName}`;
    const templateName = 'welcome';
    const additionalData = {
        name, appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};

export const sendDeactivationEmail = async (toEmail: string, name: string) => {
    const subject = 'Your access to the application has been deactivated';
    const templateName = 'deactivation';
    const additionalData = {
        name, appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};

export const sendReactivationEmail = async (toEmail: string, name: string) => {
    const subject = 'Your access to the application has been restored';
    const templateName = 'reactivation';
    const additionalData = {
        name, appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};





export const sendOtpEmail = async (email: string, otp: string, name: string, isResend: boolean = false) => {
    const subject = isResend
        ? 'Resend OTP - Verify your email'
        : 'Verify your email with OTP'; const appName = 'Gard Labour Hire';
    const year = new Date().getFullYear();


    const additionalData = {
        name,
        otp,
        appName,
        year, appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,

    };

    await sendEmail(email, subject, 'sendOtp', additionalData);
};


export const resetPasswordEmail = async (email: string, mailLink: string, name: string) => {

    const subject = 'Welcome to the Gard Labour Hire';
    const appName = 'Gard Labour Hire';
    console.log("name", name)
    const year = new Date().getFullYear();
    const additionalData = {
        appName, year, name, mailLink, appUrl: process.env.APP_URL || 'https://gard-labour-hire.com', companyLogo
    }
    await sendEmail(email, subject, 'resetPassword', additionalData)


}







export const sendNotificationEmail = async (
    toEmail: string,
    title: string,
    message: string,
    username: string,
    adminName: string,
    projectName?: string,
    phaseName?: string,
    status?: string) => {
    const subject = title;
    const templateName = 'notification';
    const additionalData = {
        title,
        message,
        username,
        adminName,
        projectName,
        phaseName,
        status,
        companyLogo,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',

    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};

export const sendDeletionEmail = async (email: string, fullName: string) => {
    try {
        const subject = 'Your Account Has Been Deleted';
        const appName = 'Gard Labour Hire';
        const year = new Date().getFullYear();

        const additionalData = {
            appName, year, fullName, companyLogo,
            appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        }

        await sendEmail(email, subject, 'deleteAccount', additionalData);
    } catch (error) {
        console.error('Error in sendDeletionEmail:', error);
        throw new Error('Failed to send deletion email');
    }
}


export const sendProfileCompletedEmail = async (
    toEmail: string,
    title: string,
    message: string,
    labourerName: string,
    labourerEmail: string,
    labourerId: string,

) => {
    const subject = title;
    const templateName = 'profileCompleted';
    const additionalData = {
        title,
        message,
        labourerName,
        labourerEmail,
        labourerId,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};

export const sendProfileUpdatedEmail = async (
    toEmail: string,
    title: string,
    message: string,
    labourerName: string,
    updatedFields: string,
    labourerId: string
) => {
    const subject = title;
    const templateName = 'labourProfileUpdated';
    const additionalData = {
        title,
        message,
        labourerName,
        updatedFields,
        labourerId,
        companyLogo,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com'
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};

export const sendLabourDeletedEmail = async (
    toEmail: string,
    title: string,
    message: string,
    labourerName: string,
    labourerEmail: string
) => {
    const subject = title;
    const templateName = 'labourDeleted';
    const additionalData = {
        title,
        message,
        labourerName,
        labourerEmail,
        companyLogo,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com'
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};



export const sendJobHardDeletedEmail = async (
    toEmail: string,
    title: string,
    message: string,
    location: string,
    companyName: string
) => {
    const subject = title;
    const templateName = 'jobHardDelete';
    const additionalData = {
        title,
        message,
        location,
        companyName,
        companyLogo,
        domainName,
        copyRightYear: new Date().getFullYear(),
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com'
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};

export const sendUserRightsRevokedEmail = async (
    toEmail: string,
    title: string,
    message: string,
    userName: string,
    rightsRevoked: string
) => {
    const subject = title;
    const templateName = 'userManagement/userRightsRevoked';
    const additionalData = {
        title,
        message,
        userName,
        rightsRevoked,
        companyLogo,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com'
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};


export const sendAllocationRequestEmail = async (
    toEmail: string,
    mailLink: string,
    name: string,
    message: string,
    location: string,
    wage: number,
    startDate: Date,
    endDate: Date,
    employee_id: string,
    companyName: string
) => {
    const subject = 'New Allocation Request from Gard-Labour-Hire';
    const templateName = 'allocationRequest';
    const additionalData = {
        name,
        message,
        location,
        wage,
        startDate: new Date(startDate).toLocaleDateString('en-AU'),
        endDate: new Date(endDate).toLocaleDateString('en-AU'),
        mailLink,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
        employeeId: employee_id,
        companyName
    };
    await sendEmail(toEmail, subject, templateName, additionalData);
};

export const sendAllocationResponseEmail = async (
    email: string,
    firstName: string,
    lastName: string,
    employeeId: string,
    allocationRequestId: string,
    status: string,
    responseNotes: string | undefined,
    startDate: Date,
    endDate: Date,
    location: string,
    wage: number | undefined,
    viewLink: string,
    statusColor: string,
    companyName: string

) => {
    const subject = 'New Allocation Request from Gard Labour Hire';
    const templateName = 'allocationRequestResponse';
    const additionalData = {
        firstName,
        lastName,
        location,
        wage,
        allocationRequestId,
        status,
        responseNotes,
        startDate: new Date(startDate).toLocaleDateString('en-AU'),
        endDate: new Date(endDate).toLocaleDateString('en-AU'),
        viewLink,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
        employeeId,
        statusColor,
        companyName
    };
    await sendEmail(email, subject, templateName, additionalData);
};

export async function sendAvailabilityCreatedEmail(
    email: string,
    title: string,
    message: string,
    userName: string,
    startDate: Date,
    endDate: Date,
    location: string,
    companyName: string,
    status: string,
    labourId: string
): Promise<void> {
    const subject = title;
    const templateName = 'availabilityCreated';
    const additionalData = {
        title,
        message,
        userName,
        startDate: new Date(startDate).toLocaleDateString('en-AU'),
        endDate: new Date(endDate).toLocaleDateString('en-AU'),
        location,
        companyName: companyName || 'N/A',
        status,
        labourId,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(email, subject, templateName, additionalData);
}

export async function sendAvailabilityUpdatedEmail(
    email: string,
    title: string,
    message: string,
    userName: string,
    startDate: Date,
    endDate: Date,
    location: string,
    companyName: string,
    status: string,
    updatedFields: string,
    labourId: string
): Promise<void> {
    const subject = title;
    const templateName = 'availabilityUpdated';
    const additionalData = {
        title,
        message,
        userName,
        startDate: new Date(startDate).toLocaleDateString('en-AU'),
        endDate: new Date(endDate).toLocaleDateString('en-AU'),
        location,
        companyName: companyName || 'N/A',
        status,
        updatedFields,
        labourId,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(email, subject, templateName, additionalData);
}
export async function sendJobClosedEmail(
    email: string,
    title: string,
    message: string,
    userName: string,
    startDate: Date,
    endDate: Date,
    location: string,
    companyName: string,
    wage: string
): Promise<void> {
    const subject = title;
    const templateName = 'jobClosed'; // new template name
    const additionalData = {
        title,
        message,
        userName,
        startDate: new Date(startDate).toLocaleDateString('en-AU'),
        endDate: new Date(endDate).toLocaleDateString('en-AU'),
        location,
        companyName: companyName || 'N/A',
        status: 'Closed',
        wage,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(email, subject, templateName, additionalData);
}



export async function sendAvailabilityDeletedEmail(
    email: string,
    title: string,
    message: string,
    userName: string,
    startDate: Date,
    endDate: Date,
    location: string,
    companyName: string,
    status: string,
    labourId: string
): Promise<void> {
    const subject = title;
    const templateName = 'availabilityDeleted';
    const additionalData = {
        title,
        message,
        userName,
        startDate: new Date(startDate).toLocaleDateString('en-AU'),
        endDate: new Date(endDate).toLocaleDateString('en-AU'),
        location,
        companyName: companyName || 'N/A',
        status,
        labourId,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(email, subject, templateName, additionalData);
}

export async function sendAllocationRequestDeletedEmail(
    email: string,
    title: string,
    message: string,
    userName: string,
    labourId: string,
    // allocationRequestId: string,
    startDate: Date,
    endDate: Date,
    location: string,
    wage: number,
    responseNotes: string,
    companyName: string
): Promise<void> {
    const subject = title;
    const templateName = 'allocationRequestDeleted';
    const additionalData = {
        title,
        message,
        userName,
        labourId,
        // allocationRequestId,
        startDate: new Date(startDate).toLocaleDateString('en-AU'),
        endDate: new Date(endDate).toLocaleDateString('en-AU'),
        location,
        wage,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
        responseNotes,
        companyName
    };
    await sendEmail(email, subject, templateName, additionalData);
}


export async function sendNewRatingEmail(
    email: string,
    title: string,
    message: string,
    labourerName: string,
    rating: number,
    feedback: string,
    raterName: string,
    labourId: string
): Promise<void> {
    const subject = title;
    const templateName = 'newRating';
    const additionalData = {
        title,
        message,
        labourerName,
        rating,
        feedback: feedback || 'None',
        raterName,
        labourId,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(email, subject, templateName, additionalData);
}

export async function sendRatingUpdatedEmail(
    email: string,
    title: string,
    message: string,
    labourerName: string,
    rating: number,
    feedback: string,
    adminName: string,
    updatedFields: string,
    labourId: string
): Promise<void> {
    const subject = title;
    const templateName = 'ratingUpdated';
    const additionalData = {
        title,
        message,
        labourerName,
        rating,
        feedback: feedback || 'None',
        adminName,
        updatedFields: updatedFields || 'N/A',
        labourId,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(email, subject, templateName, additionalData);
}

export async function sendRatingDeletedEmail(
    email: string,
    title: string,
    message: string,
    labourerName: string,
    adminName: string,
    labourId: string
): Promise<void> {
    const subject = title;
    const templateName = 'ratingDeleted';
    const additionalData = {
        title,
        message,
        labourerName,
        adminName,
        labourId,
        appUrl: process.env.APP_URL || 'https://gard-labour-hire.com',
        domainName,
        copyRightYear: new Date().getFullYear(),
        companyLogo,
    };
    await sendEmail(email, subject, templateName, additionalData);
}